import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('notifications',{attrs:{"group":"foo"}}),_c(VApp,{staticClass:"bg-spring"},[_c('vue-progress-bar'),_c('router-view',{attrs:{"name":"outer"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }